"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageClient = useStorageClient;
const StorageClient_1 = require("@juvare/platform-sdk-js/StorageClient");
const react_1 = __importDefault(require("react"));
function useStorageClient(entity, baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new StorageClient_1.StorageClient(entity, baseUrl, tokenProvider), [entity, baseUrl, tokenProvider]);
}
